import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { HtmlEditorComponent } from '../../../../../shared/html-editor/html-editor.component';
import { UserEmailTemplatesService } from '../../../../../services/crud/user-email-templates.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailTemplate } from '../../../../../dto/templates/email-template';
import { HtmlTemplateVar } from '../../../../../dto/templates/html-template-var';
import { PdfGeneratorService } from '../../../../../services/pdf-generator.service';
import { FileHelper } from '../../../../../helpers/file-helper';
import {GrapesjsEditorComponent} from '../../../../../shared/grapesjs-editor/grapesjs-editor.component';

import {SmsTemplate} from '../../../../../models/sms-template';
import {OrderSmsTemplatesService} from '../../../../services/order-sms-templates.service';

@Component({
  selector: 'app-order-sms-templates-edit',
  templateUrl: './order-sms-templates-edit.component.html',
  styleUrls: ['./order-sms-templates-edit.component.css']
})
export class OrderSmsTemplatesEditComponent implements OnInit {

  commands: HtmlTemplateVar[];

  id: number;

  selectedLanguage = 0;
  originalObj = null;
  message = '';
  lang = '';


  @ViewChild('textareamessage', { static:false }) messageInput: ElementRef;
  @ViewChild(HtmlEditorComponent, { static: false }) editor: HtmlEditorComponent;

  constructor(
    private templatesService: OrderSmsTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
  ) { }

  templateForm: FormGroup;

  selectLanguage(lang: number){


    if( Number.isNaN(this.id) ){
      alert('English template must be saved first.');
      return;
    }

    if (this.templateForm.dirty ){
      if(!confirm('Changes not saved. Do you want to proceed?')){
        return;
      }
    }

    this.navigateToLanguage(lang);

  }

  navigateToLanguage(lang: number){
    window.location.href = '/administration/templates/order-sms/'+this.id+'?lang='+lang;
  }

  addText(placeholder: string){

    const domElement = this.messageInput.nativeElement;
    const val = '*|' + placeholder + '|*';

    if (domElement.selectionStart || domElement.selectionStart === 0) {
      const startPos = domElement.selectionStart;
      const endPos = domElement.selectionEnd;
      const scrollTop = domElement.scrollTop;
      domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
      domElement.focus();
      domElement.selectionStart = startPos + val.length;
      domElement.selectionEnd = startPos + val.length;
      domElement.scrollTop = scrollTop;
    } else {
      domElement.value += val;
      domElement.focus();
    }

    this.templateForm.controls['message'+this.lang].patchValue(domElement.value);


  }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    const lang = parseInt(this.route.snapshot.queryParamMap.get('lang'));


    if (Number.isNaN(lang)) {
      this.selectedLanguage = 1;
      this.lang = 'En';
    } else {
      this.selectedLanguage = lang;

      if (this.selectedLanguage === 0) {
        this.lang = '';
      }
      else if (this.selectedLanguage === 1) {
        this.lang = 'En';
      }
      else if (this.selectedLanguage === 2) {
        this.lang = 'Es';
      }
      else if (this.selectedLanguage === 3) {
        this.lang = 'It';
      }
      else if (this.selectedLanguage === 4) {
        this.lang = 'Fr';
      }
    }

    if (Number.isNaN(this.id)) {
      const templ = new SmsTemplate();
      const date = new Date();
      templ.createDate = date;
      templ.lastModifiedDate = date;
      this.initForm(templ);
    } else {
      this.templatesService.get(this.id).subscribe(result => {

        this.originalObj = result;
        // german
        if( this.selectedLanguage === 0 ){
          this.message = result.message;
        }
        // english
        else if( this.selectedLanguage === 1 ){
          this.message = result.messageEn;
        }
        // spanish
        else if( this.selectedLanguage === 2 ){
          this.message = result.messageEs;
        }
        // italian
        else if( this.selectedLanguage === 3 ){
          this.message = result.messageIt;
        }
        // french
        else if( this.selectedLanguage === 4 ){
          this.message = result.messageFr;
        }
        else {
          alert('Language not found.');
        }



        this.initForm(result);
      });
    }
  }

  insert(command: string) {
    this.editor.insertHtml(command);
  }

  initForm(template: SmsTemplate) {

    this.templateForm = this.formBuilder.group({
      id: template.id,
      name: template.name,
      message: template.message,
      messageEn: template.messageEn,
      createDate: template.createDate,
      lastModifiedDate: template.lastModifiedDate,
    });


    this.templatesService.getVars().subscribe(result => {
      this.commands = result.data;
      //this.commandsLoaded = true;
    });
  }

  goBack() {
    this.router.navigate(['../..'], { relativeTo: this.route });
  }

  onSubmit(form: FormGroup) {


    if (Number.isNaN(this.id)) {

      this.templatesService.add(form.value).subscribe(res => {
        this.id = res;
        this.navigateToLanguage(this.selectedLanguage);
      });
    } else {
      this.templatesService.update(this.id, form.value).subscribe(res => this.navigateToLanguage(this.selectedLanguage));
    }
  }

}
